/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Support/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Support({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Support",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let fill2OrdtColorsNeutral400 = fill2 ?? dtColorsNeutral400
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Support.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z2qDjUp': alignSelf,'--mt-2-Z2qDjUp': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2qDjUp': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2qDjUp': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2qDjUp': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2qDjUp': opacity,'--w-10-Z2qDjUp': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2qDjUp': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2qDjUp': fill,'--a-7-Z2qDjUp': isAnimated ? animation : "none",'--sd-8-Z2qDjUp': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2qDjUp': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Support.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.571 2A3.571 3.571 0 002 5.571V18.43A3.571 3.571 0 005.571 22H18.43A3.571 3.571 0 0022 18.429V5.57A3.571 3.571 0 0018.429 2H5.57zM12 7.564c-1.098 0-1.988.89-1.988 1.988a.893.893 0 01-1.785 0 3.774 3.774 0 114.666 3.667v.756a.893.893 0 11-1.786 0v-1.543c0-.493.4-.893.893-.893a1.988 1.988 0 100-3.975zm0 11.632a1.179 1.179 0 100-2.358 1.179 1.179 0 000 2.358z"
 style={{'--f-12-Z2qDjUp': fill2OrdtColorsNeutral400}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}